import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  inlineTabs?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  actions,
  inlineTabs
}: PageHeaderProps) {
  return <header className="flex min-h-[60px] flex-wrap items-center justify-between gap-3 border-b border-ink-200 bg-white px-6 py-3" data-id="element-359" data-mp="kr6p5kqnbzz7">
      <div className="flex min-w-0 items-center gap-5" data-id="element-360" data-mp="ppi05ysoggj0">
        <div className="min-w-0" data-id="element-361" data-mp="tsodfqe7j7yz">
          <h1 className="truncate text-[19px] font-bold leading-tight text-ink-900" data-id="element-362" data-mp="trd7pl17bq58">{title}</h1>
          {subtitle && <p className="mt-0.5 text-[13px] text-ink-500" data-id="element-363" data-mp="yq6gj05jmsz2">{subtitle}</p>}
        </div>
        {inlineTabs}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2" data-id="element-364" data-mp="18ivq1phj9wrr">{actions}</div>}
    </header>;
}